import React, { useState } from 'react';
import { message, Spin } from 'antd';
import classNames from 'classnames';
import { ShareIcon } from 'icons';
import { useTranslations } from 'next-intl';

import { useAppSelector } from 'store';

import { globalConst } from 'modules/global';

import { ShareModal } from 'components';

import { useFollowTeacher, useUnFollowTeacher } from '../hooks';

interface IProps {
  slug?: string;
  teacherId?: number;
  isFollowed?: boolean;
}

const FollowAndShare: React.FC<IProps> = ({ slug, isFollowed, teacherId }) => {
  const t = useTranslations();
  const [openShare, setOpenShare] = useState(false);
  const [followed, setFollowed] = useState(isFollowed);
  const isAuth = useAppSelector(({ user }) => user?.phone);
  const { mutate: followMutation, isLoading: isFollowing } = useFollowTeacher();
  const { mutate: unFollowMutation, isLoading: isUnFollowing } = useUnFollowTeacher();

  const onFollowToggle = () => {
    if (isFollowing || isUnFollowing) return;

    if (!isAuth) {
      message.info(`${t('kurslarni_saqlab_olish_uchun_royxatdan_oting')}`);
      return;
    }

    if (followed) {
      unFollowMutation(teacherId, {
        onSuccess: () => setFollowed(false)
      });
    } else {
      followMutation(teacherId, {
        onSuccess: () => setFollowed(true)
      });
    }
  };

  return (
    <div className="mt-3 flex items-center gap-2">
      <div className="w-full flex-1">
        <Spin spinning={isFollowing || isUnFollowing}>
          <button
            onClick={onFollowToggle}
            className={classNames(
              'text-md w-full cursor-pointer rounded-lg border-transparent  py-1.5 font-medium disabled:opacity-50',
              {
                'bg-green-500 text-white hover:bg-green-600': !followed,
                'bg-red-50 text-red-500 hover:bg-red-600 hover:text-white': followed
              }
            )}
          >
            {followed ? t('bekor_qilish') : t('obuna_bolish')}
          </button>
        </Spin>
      </div>
      <div>
        <button
          onClick={() => setOpenShare(true)}
          className="w-full cursor-pointer rounded-lg bg-purple-600 px-3 py-2 text-white hover:bg-purple-700"
          disabled={isFollowing || isUnFollowing}
        >
          <ShareIcon className="size-5" />
        </button>
      </div>

      <ShareModal
        title={t('profilni_ulashish')}
        shareUrl={`${globalConst.pageNames.TEACHER}/${slug}`}
        open={openShare}
        onClose={() => setOpenShare(false)}
      />
    </div>
  );
};

export default FollowAndShare;
